export default __webpack_public_path__ + "static/media/OilBlending.9854fd8b.jpg";